var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 165,
    viewBox: "0 0 255 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 166,
    r: 85,
    fill: "#E3A2A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.494 80.9881C183.679 80.9881 195.988 68.6786 195.988 53.4941C195.988 38.3095 183.679 26 168.494 26C153.31 26 141 38.3095 141 53.4941C141 68.6786 153.31 80.9881 168.494 80.9881Z",
    fill: "#F5D27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C214.944 251 253 212.944 253 166C253 119.056 214.944 81 168 81C121.056 81 83 119.056 83 166C83 212.944 121.056 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C209.103 251 242.423 212.944 242.423 166C242.423 119.056 209.103 81 168 81C126.898 81 93.5781 119.056 93.5781 166C93.5781 212.944 126.898 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C203.208 251 231.75 212.944 231.75 166C231.75 119.056 203.208 81 168 81C132.792 81 104.25 119.056 104.25 166C104.25 212.944 132.792 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C197.314 251 221.077 212.944 221.077 166C221.077 119.056 197.314 81 168 81C138.686 81 114.922 119.056 114.922 166C114.922 212.944 138.686 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C191.472 251 210.5 212.944 210.5 166C210.5 119.056 191.472 81 168 81C144.528 81 125.5 119.056 125.5 166C125.5 212.944 144.528 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C185.631 251 199.923 212.944 199.923 166C199.923 119.056 185.631 81 168 81C150.37 81 136.078 119.056 136.078 166C136.078 212.944 150.37 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C179.736 251 189.25 212.944 189.25 166C189.25 119.056 179.736 81 168 81C156.264 81 146.75 119.056 146.75 166C146.75 212.944 156.264 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251C173.842 251 178.577 212.944 178.577 166C178.577 119.056 173.842 81 168 81C162.158 81 157.422 119.056 157.422 166C157.422 212.944 162.158 251 168 251Z",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168 251V81",
    stroke: "#F5D27A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnion);
export default __webpack_public_path__ + "story3-frontend/static/media/onion.69430f8ef711d6b307adc054820fd729.svg";
export { ForwardRef as ReactComponent };